<template>
    <span
        class="view-information"
        data-testid="view-information-link"
        @click="showModal = true"
    >View information</span>
    <Teleport to="body">
        <InformationModal
            :show="showModal"
            @close="showModal = false"
        >
            <template #header>
                {{ " " }}
            </template>
            <template #body>
                <span class="span-style">Configure Metrics is a globalconfiguration page that gives you the
                    option to choose the metrics you want to see and how you want to see them on our Performance reports.
                    Here's a list of all the things you can do to build the right reports for your business!</span><br>
                <h3>Enable / Disable Metrics text</h3>
                <span class="span-style">Want to see some metrics, but not others? Configure Metrics lets you
                    choose which metrics should show in our Performance reports. Enable the metrics your want
                    to see and Disable the ones you don't!</span><br>
                <h3>Customise Metric Names</h3>
                <span class="span-style">Does your business call a metric by a different name? Maybe you'd like
                    to simplify some of our metrics to improve readability in reports. Configure Metrics lets you
                    'rename' a metric by adding a custom label, which will then be used to display the metric in reports! </span><br>
                <h3>Customise Metric Formats</h3>
                <span class="span-style">Coming soon!</span><br>
                <h3>Restrict metrics based on Business Role </h3>
                <h4>Coming soon!</h4>
            </template>
        </InformationModal>
    </Teleport>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { InformationModal } from '@/components';
const showModal = ref(false);
</script>
<style lang="scss">
    .header-row {
        .view-information {
            color: var(--color-playvox-green-60);
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-top: 8px;
            cursor: pointer;

            @media (max-width: 767px) {
                margin: 0px;
            }
        }
    }

    .modal-body{
        padding: 8px;
    }
    
    .span-style{
      font-size:14px;
    }
</style>